export const actions = {
    signup: "SIGNUP",
    login: "LOGIN",
    getUser: "GETUSER",
    getStore: "GETSTORE",
    getLogs:  "GETLOGS",
    createStore: "CREATESTORE",
    getStores: "GETSTORES",
    getStoreProducts: "GETSTOREPRODUCTS",
    createProductGroup: "CREATEPRODUCTGROUP",
    getStoreProductGroups: "GETSTOREPRODUCTGROUPS",
    editProduct: "EDITPRODUCT",
    deleteProductGroup: "DELETEPRODUCTGROUP",
    reInitiateStore: "REINITIATESTORE",
    deleteStore: "DELETESTORE",
    editProductGroup: "EDITPRODUCTGROUP",
    getProductGroupProducts: "GETPRODUCTGROUPPRODUCTS",
    addProduct: "ADDPRODUCT",
    removeProduct: "REMOVEPRODUCT",
    getProduct: "GETPRODUCT",
    addProducts: "ADDPRODUCTS",
    getAllProductGroupProducts: "GETAllPRODUCTGROUPPRODUCTS",
    clearLog: "CLEARLOG",
    getAnalytics: "GETANALYTICS",
    getAnalyticsProduct: "GETANALYTICSPRODUCT",
    getAnalyticsAll: "GETANALYTICSALL",
    getShipmentProviders: "GETSHIPMENTPROVIDERS",
    startPendingBot: "STARTPENDINGBOT",
    stopPendingBot: "STOPPENDINGBOT",
    addReadyToShipBotEmail: "ADDREADYTOSHIPBOTEMAIL",
    deleteReadyToShipBotEmail: "DELETEREADYTOSHIPBOTEMAIL",
    addXlsxBotEmail: "ADDXLSXBOTEMAIL",
    deleteXlsxBotEmail: "DELETEXLSXBOTEMAIL",
    startReadyToShipBot: "startReadyToShipBot",
    stopReadyToShipBot: "stopReadyToShipBot",
    stopStore: "stopStore",
    getActionLogs: "GETACTIONLOGS",
    saveActionLog: "SAVEACTIONLOG",
    deleteActionLog: "DELETEACTIONLOG",
    getTokenHealth: "GETTOKENHEALTH",
    refreshTokens: "REFRESHTOKENS",
    getJumiaPrice: "GETJUMIAPRICE",
    updateJumiaPrice: "UPDATEJUMIAPRICE",
    getTrackedSkus: "GETTRACKEDSKUS",
    addTrackedSku: "ADDTRACKEDSKU",
    removeTrackedSku: "REMOVETRACKEDSKU",
    updateTrackedSkuReason: "UPDATETRACKEDSKUREASON",
    getStockIntelligence:   "GETSTOCKINTELLIGENCE",
    getInventorySummary:    "GETINVENTORYSUMMARY",
    addInventoryMovement:   "ADDINVENTORYMOVEMENT",
    purchaseInventory:      "PURCHASEINVENTORY",
    importInventory:        "IMPORTINVENTORY",
    getInventoryImports:    "GETINVENTORYIMPORTS",
    updateInventoryStock:   "UPDATEINVENTORYSTOCK",
    updateInventorySyncSettings: "UPDATEINVENTORYSYNCSETTINGS",
    syncGroupToJumia:       "SYNCGROUPTOJUMIA",
    syncAllToJumia:         "SYNCALLTOJUMIA",
    getJumiaSyncAllStatus:  "GETJUMIASYNCALLSTATUS",
    syncGroupToMarjan:      "SYNCGROUPTOMARJAN",
    syncAllToMarjan:        "SYNCALLTOMARJAN",
    getMarjanSyncAllStatus: "GETMARJANSYNCALLSTATUS",
    updateMarketInfo:       "UPDATEMARKETINFO",
    getUnassociatedSkus:    "GETUNASSOCIATEDSKUS",
    getAssociatedSkus:      "GETASSOCIATEDSKUS",
    getGroupsDetail:        "GETGROUPSDETAIL",
    getSkuSuggestions:      "GETSKUSUGGESTIONS",
    bulkAssignSkus:         "BULKASSIGNSKUS",
    moveSkuToGroup:         "MOVESKUTOGROUP",
    getAssociationHistory:  "GETASSOCIATIONHISTORY",
    setGroupImageFromSku:   "SETGROUPIMAGEFROMSKU",
    autoFixGroupImages:     "AUTOFIXGROUPIMAGES",
    getSkusByGroup:         "GETSKUSBYGROUP",
    searchAllSkus:          "SEARCHALLSKUS",
    getPricingOpportunities: "GETPRICINGOPPORTUNITIES",
    simulatePricing:         "SIMULATEPRICING",
    applyPrice:              "APPLYPRICE",
    bulkApplyPrices:         "BULKAPPLYPRICES",
    getBulkApplyStatus:      "GETBULKAPPLYSTATUS",
    getPricingLogs:          "GETPRICINGLOGS",
    getPricingSettings:      "GETPRICINGSETTINGS",
    savePricingSettings:     "SAVEPRICINGSETTINGS",
    syncPrices:              "SYNCPRICES",
    getSyncStatus:           "GETSYNCSTATUS",
    liveSyncSkus:            "LIVESYNCSKUS",
    startCatalogScan:        "STARTCATALOGSCAN",
    getCatalogScanStatus:    "GETCATALOGSSCANSTATUS",
    syncStock:               "SYNCSTOCK",
    getStockSyncStatus:      "GETSTOCKSYNCSTATUS",
    bulkUpdateStock:         "BULKUPDATESTOCK",
    getBulkStockStatus:      "GETBULKSTOCKSTATUS",
    mergeGroups:             "MERGEGROUPS",
    cleanupEmptyGroups:      "CLEANUPEMPTYGROUPS",
    // ── Auto-Associate ────────────────────────────────────────────────────────
    startAutoAssociate:        "STARTAUTOASSOCIATE",
    getAutoAssociateStatus:    "GETAUTOASSOCIATESTATUS",
    getPendingAssociations:    "GETPENDINGASSOCIATIONS",
    applyPendingAssociations:  "APPLYPENDINGASSOCIATIONS",
    clearPendingAssociations:  "CLEARPENDINGASSOCIATIONS",
    // ── Auth ─────────────────────────────────────────────────────────────────
    forgotPassword:          "FORGOTPASSWORD",
    resetPassword:           "RESETPASSWORD",
    // ── Admin user management ─────────────────────────────────────────────────
    getAdminUsers:           "GETADMINUSERS",
    approveUser:             "APPROVEUSER",
    denyUser:                "DENYUSER",
    updateUserPermissions:   "UPDATEUSERPERMISSIONS",
    deleteAdminUser:         "DELETEADMINUSER",
    adminResetPassword:      "ADMINRESETPASSWORD",
    // ── Buying Decisions ──────────────────────────────────────────────────────
    getBuyingDecisions:      "GETBUYINGDECISIONS",
    // ── Auto-Pilot pricing ────────────────────────────────────────────────────
    getAutoPilotOverview:    "GETAUTOPILOTOVERVIEW",
    saveAutoPilotSettings:   "SAVEAUTOPILOTSETTINGS",
    marjanPilotStatus: "MARJANPILOTSTATUS",
    marjanPilotSet: "MARJANPILOTSET",
    jumiaFeesStatus:         "JUMIAFEESSTATUS",
    jumiaFeesImport:         "JUMIAFEESIMPORT",
    autoPilotEnroll:         "AUTOPILOTENROLL",
    autoPilotToggle:         "AUTOPILOTTOGGLE",
    autoPilotRemove:         "AUTOPILOTREMOVE",
    autoPilotReset:          "AUTOPILOTRESET",
    autoPilotPreview:        "AUTOPILOTPREVIEW",
    autoPilotRun:            "AUTOPILOTRUN",
    getAutoPilotRunStatus:   "GETAUTOPILOTRUNSTATUS",
    getAutoPilotRuns:        "GETAUTOPILOTRUNS",
    getAutoPilotRun:         "GETAUTOPILOTRUN",
    getAutoPilotSku:         "GETAUTOPILOTSKU",
    // ── Auto-Pilot winners (page-competition tier) ───────────────────────────
    getListingIssues:        "GETLISTINGISSUES",
    recheckListingIssues:    "RECHECKLISTINGISSUES",
    getAutoPilotWinners:     "GETAUTOPILOTWINNERS",
    autoPilotWinnersDetect:  "AUTOPILOTWINNERSDETECT",
    autoPilotWinnersScan:    "AUTOPILOTWINNERSSCAN",
    getAutoPilotWinnerScanStatus: "GETAUTOPILOTWINNERSCANSTATUS",
    autoPilotWinnersAdd:     "AUTOPILOTWINNERSADD",
    autoPilotWinnersRemove:  "AUTOPILOTWINNERSREMOVE",
    autoPilotWinnerUpdate:   "AUTOPILOTWINNERUPDATE",
    autoPilotWinnerComparable: "AUTOPILOTWINNERCOMPARABLE",
    autoPilotWinnerTestSearch: "AUTOPILOTWINNERTESTSEARCH",
    // ── Product Radar ────────────────────────────────────────────────────────
    getRadarOverview:        "GETRADAROVERVIEW",
    getRadarTree:            "GETRADARTREE",
    radarTreeExpand:         "RADARTREEEXPAND",
    radarTreeCrawl:          "RADARTREECRAWL",
    radarAddWatch:           "RADARADDWATCH",
    radarCheckWatch:         "RADARCHECKWATCH",
    radarUpdateWatch:        "RADARUPDATEWATCH",
    radarRemoveWatches:      "RADARREMOVEWATCHES",
    radarScan:               "RADARSCAN",
    getRadarScanStatus:      "GETRADARSCANSTATUS",
    getRadarListings:        "GETRADARLISTINGS",
    getRadarPicks:           "GETRADARPICKS",
    saveRadarPicksSettings:  "SAVERADARPICKSSETTINGS",
    radarPicksDetectChat:    "RADARPICKSDETECTCHAT",
    radarPicksPreview:       "RADARPICKSPREVIEW",
    radarPicksRun:           "RADARPICKSRUN",
    radarPickStatus:         "RADARPICKSTATUS",
    // ── Marjan (Octopia) ──────────────────────────────────────────────────────
    getMarjanStores:         "GETMARJANSTORES",
    createMarjanStore:       "CREATEMARJANSTORE",
    updateMarjanStore:       "UPDATEMARJANSTORE",
    deleteMarjanStore:       "DELETEMARJANSTORE",
    testMarjanStore:         "TESTMARJANSTORE",
    getMarjanOverview:       "GETMARJANOVERVIEW",
    getMarjanOrders:         "GETMARJANORDERS",
    syncMarjanStore:         "SYNCMARJANSTORE",
    getMarjanSyncStatus:     "GETMARJANSYNCSTATUS",
    updateMarjanStock:       "UPDATEMARJANSTOCK",
    updateMarjanPrice:       "UPDATEMARJANPRICE",
    // ── Marjan finance (payouts / profit) ────────────────────────────────────
    syncMarjanFinance:       "SYNCMARJANFINANCE",
    getMarjanFinanceStatus:  "GETMARJANFINANCESTATUS",
    getMarjanPayouts:        "GETMARJANPAYOUTS",
    getMarjanPayoutLines:    "GETMARJANPAYOUTLINES",
    getMarjanProfit:         "GETMARJANPROFIT",
    getMarjanProducts:       "GETMARJANPRODUCTS",
    getMarjanGroups:         "GETMARJANGROUPS",
    getMarjanLinkSuggestions:"GETMARJANLINKSUGGESTIONS",
    setMarjanLink:           "SETMARJANLINK",
    removeMarjanLink:        "REMOVEMARJANLINK",
    // ── Marjan SKU association ───────────────────────────────────────────────
    getMarjanAssocSkus:      "GETMARJANASSOCSKUS",
    getMarjanAssocGroups:    "GETMARJANASSOCGROUPS",
    getMarjanAssocByGroup:   "GETMARJANASSOCBYGROUP",
    marjanBulkLink:          "MARJANBULKLINK",
    marjanApplySuggestions:  "MARJANAPPLYSUGGESTIONS",
    marjanUnlink:            "MARJANUNLINK",
    marjanCreateGroup:       "MARJANCREATEGROUP",
    marjanAutoSuggest:       "MARJANAUTOSUGGEST",
    getMarjanAssocHistory:   "GETMARJANASSOCHISTORY",
    getMarjanBelowCost:      "GETMARJANBELOWCOST",
    confirmMarjanBelowCost:  "CONFIRMMARJANBELOWCOST",
    marjanSyncImages:        "MARJANSYNCIMAGES",
    marjanAutoAssociateStart:"MARJANAUTOASSOCIATESTART",
    marjanAutoAssociateStatus:"MARJANAUTOASSOCIATESTATUS",
    getMarjanPending:        "GETMARJANPENDING",
    retargetMarjanPending:   "RETARGETMARJANPENDING",
    applyMarjanPending:      "APPLYMARJANPENDING",
    clearMarjanPending:      "CLEARMARJANPENDING",
    // ── Net Profit ────────────────────────────────────────────────────────────
    getProfitSummary:        "GETPROFITSUMMARY",
    getProfitMonthly:        "GETPROFITMONTHLY",
    getProfitTodayEstimate:  "GETPROFITTODAYESTIMATE",
    inventoryPackGet:        "INVENTORYPACKGET",
    inventoryPackSave:       "INVENTORYPACKSAVE",
    inventoryMinProfit:      "INVENTORYMINPROFIT",
    inventoryPackCandidates: "INVENTORYPACKCANDIDATES",
    getProfitCategories:     "GETPROFITCATEGORIES",
    getAutoPilotVerdict:     "GETAUTOPILOTVERDICT",
    getExpenses:             "GETEXPENSES",
    createExpense:           "CREATEEXPENSE",
    updateExpense:           "UPDATEEXPENSE",
    deleteExpense:           "DELETEEXPENSE",
    getProfitSettings:       "GETPROFITSETTINGS",
    saveProfitSettings:      "SAVEPROFITSETTINGS",
    // ── Warehouse ─────────────────────────────────────────────────────────────
    getWarehouseSlotting:    "GETWAREHOUSESLOTTING",
    getWarehouseMap:         "GETWAREHOUSEMAP",
    generateWarehouseLocations: "GENERATEWAREHOUSELOCATIONS",
    createWarehouseLocation: "CREATEWAREHOUSELOCATION",
    updateWarehouseLocation: "UPDATEWAREHOUSELOCATION",
    deleteWarehouseLocation: "DELETEWAREHOUSELOCATION",
    assignWarehouseSlot:     "ASSIGNWAREHOUSESLOT",
    assignWarehouseBulk:     "ASSIGNWAREHOUSEBULK",
    buildWarehousePlan:      "BUILDWAREHOUSEPLAN",
    warehousePlanPdf:        "WAREHOUSEPLANPDF",
    warehouseLocationLabels: "WAREHOUSELOCATIONLABELS",
    warehouseProductLabels:  "WAREHOUSEPRODUCTLABELS",
    getWarehouseMoves:       "GETWAREHOUSEMOVES",
    snoozeWarehouseMove:     "SNOOZEWAREHOUSEMOVE",
    // Jumia product listing (create a fiche produit)
    listingCategories:       "LISTINGCATEGORIES",
    listingCategoriesSync:   "LISTINGCATEGORIESSYNC",
    listingBrands:           "LISTINGBRANDS",
    listingBrandsSync:       "LISTINGBRANDSSYNC",
    listingBrandSuggest:     "LISTINGBRANDSUGGEST",
    listingGroups:           "LISTINGGROUPS",
    listingMarjanCatRefresh: "LISTINGMARJANCATREFRESH",
    listingMarjanEans:       "LISTINGMARJANEANS",
    listingMarjanEansUpload: "LISTINGMARJANEANSUPLOAD",
    listingMarjanReference:  "LISTINGMARJANREFERENCE",
    listingAiImport:         "LISTINGAIIMPORT",
    listingAiContent:        "LISTINGAICONTENT",
    listingAiUsage:          "LISTINGAIUSAGE",
    listingAiBudget:         "LISTINGAIBUDGET",
    listingMarjanCategories: "LISTINGMARJANCATEGORIES",
    listingMarjanAttributes: "LISTINGMARJANATTRIBUTES",
    listingMarjanBrands:     "LISTINGMARJANBRANDS",
    listingMarjanGtin:       "LISTINGMARJANGTIN",
    listingPublish:          "LISTINGPUBLISH",
    listingSyncStatus:       "LISTINGSYNCSTATUS",
    listingAttributeSet:     "LISTINGATTRIBUTESET",
    listingImages:           "LISTINGIMAGES",
    listingImageFromUrl:     "LISTINGIMAGEFROMURL",
    listingSource:           "LISTINGSOURCE",
    listingPreview:          "LISTINGPREVIEW",
    listingCreate:           "LISTINGCREATE",
    listingList:             "LISTINGLIST",
    listingStats:            "LISTINGSTATS",
    listingCoverage:         "LISTINGCOVERAGE",
    // Spread: where a product already is per store, other categories it fits, cooldown
    listingGroupCoverage:    "LISTINGGROUPCOVERAGE",
    listingCategorySuggest:  "LISTINGCATEGORYSUGGEST",
    listingRotateCategories: "LISTINGROTATECATEGORIES",
    listingRecentCreations:  "LISTINGRECENTCREATIONS",
    listingCategoryAi:       "LISTINGCATEGORYAI",
    // Spread queue (bulk copies into the stores that lack a product)
    spreadStatus:            "SPREADSTATUS",
    spreadPlan:              "SPREADPLAN",
    spreadSettings:          "SPREADSETTINGS",
    spreadRunStore:          "SPREADRUNSTORE",
    // Listing strategies (named creation strategies, status + actions)
    listingStrategies:       "LISTINGSTRATEGIES",
    listingStrategyAction:   "LISTINGSTRATEGYACTION",
    decisionsList:           "DECISIONSLIST",
    decisionsDaily:          "DECISIONSDAILY",
    decisionCreate:          "DECISIONCREATE",
    decisionDelete:          "DECISIONDELETE",
    decisionGroups:          "DECISIONGROUPS",
    weeklyReports:           "WEEKLYREPORTS",
    weeklyReport:            "WEEKLYREPORT",
    weeklyReportRun:         "WEEKLYREPORTRUN",
    listingRefresh:          "LISTINGREFRESH",
    listingSuggestSku:       "LISTINGSUGGESTSKU",
    listingRetry:            "LISTINGRETRY",
    // Returns & claims center
    returnsCases:            "RETURNSCASES",
    returnsSummary:          "RETURNSSUMMARY",
    returnsStores:           "RETURNSSTORES",
    returnsSync:             "RETURNSSYNC",
    returnsUpdate:           "RETURNSUPDATE",
    returnsDraftClaim:       "RETURNSDRAFTCLAIM",
    returnsSendClaim:        "RETURNSSENDCLAIM",
    returnsMarjanTickets:    "RETURNSMARJANTICKETS",
    returnsConfig:           "RETURNSCONFIG",
    returnsTracking:         "RETURNSTRACKING",
    returnsManifest:         "RETURNSMANIFEST",
    // Daily Shipments (hand-over to Jumia / Marjane vs paper bilan)
    handoverDays:            "HANDOVERDAYS",
    handoverDay:             "HANDOVERDAY",
    handoverAddSheet:        "HANDOVERADDSHEET",
    handoverRerunSheet:      "HANDOVERRERUNSHEET",
    handoverAddRow:          "HANDOVERADDROW",
    handoverUpdateRow:       "HANDOVERUPDATEROW",
    handoverDeleteSheet:     "HANDOVERDELETESHEET",
    handoverNotes:           "HANDOVERNOTES",
    handoverApply:           "HANDOVERAPPLY",
    handoverUndo:            "HANDOVERUNDO",
    handoverBackfill:        "HANDOVERBACKFILL",
    handoverBackfillStatus:  "HANDOVERBACKFILLSTATUS",
    // My Store (Shopify)
    shopifyStatus:           "SHOPIFYSTATUS",
    shopifyCandidates:       "SHOPIFYCANDIDATES",
    shopifyProducts:         "SHOPIFYPRODUCTS",
    shopifySync:             "SHOPIFYSYNC",
    shopifySyncStatus:       "SHOPIFYSYNCSTATUS",
    shopifyProductStatus:    "SHOPIFYPRODUCTSTATUS",
    shopifyProductRefresh:   "SHOPIFYPRODUCTREFRESH",
    shopifyPushStock:        "SHOPIFYPUSHSTOCK",
    shopifyRegisterWebhooks: "SHOPIFYREGISTERWEBHOOKS",
    shopifyArabic:           "SHOPIFYARABIC",
    shopifyArabicStatus:     "SHOPIFYARABICSTATUS",
}
